import React from 'react';
import gtag from 'ga-gtag';
import { useLocation } from 'react-router-dom';
import Footer from 'components/Footer';
import Navbar from 'components/Navbar';
import TipsCard from 'components/TipsCard';
import parse from 'html-react-parser';

// style
import './TipsDetailsPageStyle.css';

const item = {
  posted_by: {
    name: 'Nurudeen Ajayi',
  },
  image_link:
    'https://images.pexels.com/photos/2988860/pexels-photo-2988860.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
  date_posted: 'Nov 23, 2020',
  title: 'How to advertise on Aso Property',
  body: `<p><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">
  A quick and simplified answer is that&nbsp;</span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">Lorem Ipsum</strong>
  <span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;refers to text that the DTP (Desktop Publishing) industry use as replacement text when the real text is not available. ...&nbsp;
  </span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">Lorem Ipsum</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;is dummy text which has no&nbsp;
  </span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">meaning</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;however looks very similar to real text.
  </span></p>\r\n<p>&nbsp;</p>\r\n<p><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">A quick and simplified answer is that&nbsp;</span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">
  Lorem Ipsum</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">
  &nbsp;refers to text that the DTP (Desktop Publishing) industry use as replacement text when the real text is not available. ...&nbsp;</span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">Lorem Ipsum</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">
  &nbsp;is dummy text which has no&nbsp;
  </span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">meaning</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;however looks very similar to real text.</span></p>
  <p><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">A quick and simplified answer is that&nbsp;</span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">Lorem Ipsum</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;refers to text that the DTP (Desktop Publishing) industry use as replacement text when the real text is not available. ...&nbsp;</span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">Lorem Ipsum</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;is dummy text which has no&nbsp;</span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">meaning</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;however looks very similar to real text.</span></p>\r\n<p>&nbsp;</p>\r\n<p><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">A quick and simplified answer is that&nbsp;</span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">Lorem Ipsum</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;refers to text that the DTP (Desktop Publishing) industry use as replacement text when the real text is not available. ...&nbsp;</span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">Lorem Ipsum</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;is dummy text which has no&nbsp;</span><strong style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">meaning</strong><span style=\"color: #202124; font-family: arial, sans-serif; font-size: 16px; background-color: #ffffff;\">&nbsp;however looks very similar to real text.</span></p>
  `,
};

const TipsDetailsPage = () => {
  const { state } = useLocation();
  const { tipsAndGuide } = state;

  const trackTipsAndGuidePage = () => {
    gtag('event', 'tips_and_guides_page', {
      method: 'tips_and_guides_page',
    });
  };

  React.useEffect(() => {
    trackTipsAndGuidePage();
    window.scrollTo({ behavior: 'smooth', top: 0 });
  }, []);

  return (
    <section className="tipsdetailspage">
      <Navbar />
      <div className="tipsdetailspage-banner">
        <img src={tipsAndGuide.image_link} alt="article banner" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-2" />
          <div className="col-md-8">
            <div className="tipsdetails">
              <h1>{tipsAndGuide.title}</h1>
              <div className="tipsdetails-flex">
                <span className="tipsdetails-author">
                  {tipsAndGuide.posted_by.name}
                </span>
                <span className="tipsdetails-date">
                  {tipsAndGuide.date_posted} <span>4 min read</span>
                </span>
              </div>
              <div className="tipsdetails-content">{parse(tipsAndGuide.body)}</div>
            </div>
          </div>
          <div className="col-md-2" />
        </div>
        <h1 className="tipsdetails-recentarticles_header">Recent Articles</h1>
        <div className="row">
          <div className="col-md-4">
            <TipsCard {...item} />
          </div>
          <div className="col-md-4">
            <TipsCard {...item} />
          </div>
          <div className="col-md-4">
            <TipsCard {...item} />
          </div>
        </div>
        <h1 className="tipsdetails-relatedarticles_header">More Related Articles</h1>
        <div className="row">
          <div className="col-md-4">
            <TipsCard {...item} />
          </div>
          <div className="col-md-4">
            <TipsCard {...item} />
          </div>
          <div className="col-md-4">
            <TipsCard {...item} />
          </div>
        </div>
      </div>
      <div className="tipsdetails-footer">
        <Footer />
      </div>
    </section>
  );
};

export default TipsDetailsPage;
